export function nouislidersHandler() {
  const sliders = document.querySelectorAll(".range-slider");
  if (!sliders.length) return;

  sliders.forEach(slider => rangeHandler(slider));

}

function rangeHandler(slider) {
  if (!slider || typeof noUiSlider === "undefined") return;

  // Read values from data attributes
  const min = parseInt(slider.dataset.min, 10);
  const max = parseInt(slider.dataset.max, 10);
  const step = parseInt(slider.dataset.step, 10);
  const startMin = parseInt(slider.dataset.startMin, 10);
  const startMax = parseInt(slider.dataset.startMax, 10);

  const minInput = slider.closest('.filter-range').querySelector('.range-inputs__item:first-of-type input[type="number"]');
  const maxInput = slider.closest('.filter-range').querySelector('.range-inputs__item:last-of-type input[type="number"]');

  if (!minInput || !maxInput) return;


  // Initialize noUiSlider
  noUiSlider.create(slider, {
    start: [startMin, startMax],
    connect: true,
    range: { min, max },
    step,
    tooltips: [true, true],
    format: {
      to: value => Math.round(value),
      from: value => Number(value),
    }
  });

  // Update inputs when slider moves
  slider.noUiSlider.on("update", (values, handle) => {
    if (handle === 0) {
      minInput.value = values[0];
    } else {
      maxInput.value = values[1];
    }
  });

  // Update slider when inputs change
  [minInput, maxInput].forEach(input => {
    input.addEventListener("change", () => {
      let minVal = parseInt(minInput.value, 10);
      let maxVal = parseInt(maxInput.value, 10);

      if (minVal > maxVal) {
        [minVal, maxVal] = [maxVal, minVal]; // swap values
      }

      slider.noUiSlider.set([minVal, maxVal]);
    });
  });
}